module.exports = __webpack_public_path__ + "static/media/bay-beach-clouds.39f7c8e5.jpg";